import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/suggestedActions/SuggestedActions.module_built.css";
const classes = {"suggested-actions--stacked":"wy3OzFW_suggested-actions--stacked","suggested-actions":"wy3OzFW_suggested-actions","suggested-actions--flow":"wy3OzFW_suggested-actions--flow"}
export default classes

const _suggested_actions__stacked0 = classes["suggested-actions--stacked"]
export { _suggested_actions__stacked0 as "suggested-actions--stacked" }

const _suggested_actions0 = classes["suggested-actions"]
export { _suggested_actions0 as "suggested-actions" }

const _suggested_actions__flow0 = classes["suggested-actions--flow"]
export { _suggested_actions__flow0 as "suggested-actions--flow" }
